import { render, staticRenderFns } from "./TaskTypeDefectsAndViolations.vue?vue&type=template&id=6abd598a"
import script from "./TaskTypeDefectsAndViolations.vue?vue&type=script&lang=js"
export * from "./TaskTypeDefectsAndViolations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports